// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__FAMO7","messages":"Chat_messages__2UyCD","dateDivider":"Chat_dateDivider__2mNFY"};